/**
 * All events posted from iframe
 */
export var MSG_NAME_FROM_IFRAME;
(function (MSG_NAME_FROM_IFRAME) {
    MSG_NAME_FROM_IFRAME["QaAssistantClose"] = "ABTASTY_QA_ASSISTANT_CLOSE";
    MSG_NAME_FROM_IFRAME["FsApplyForcedVariations"] = "FS_APPLY_FORCED_VARIATIONS";
    MSG_NAME_FROM_IFRAME["FsResetForcedVariations"] = "FS_RESET_FORCED_VARIATIONS";
    MSG_NAME_FROM_IFRAME["FsQaAssistantReady"] = "FS_QA_ASSISTANT_READY";
    MSG_NAME_FROM_IFRAME["MinimizeQaAssistantClose"] = "ABTASTY_QA_MINIMIZE_QA_ASSISTANT_CLOSE";
    MSG_NAME_FROM_IFRAME["FsTriggerRender"] = "FS_TRIGGER_RENDER";
    MSG_NAME_FROM_IFRAME["QaAssistantPlatformChoiceLoaded"] = "ABTASTY_QA_ASSISTANT_PLATFORM_CHOICE_LOADED";
})(MSG_NAME_FROM_IFRAME || (MSG_NAME_FROM_IFRAME = {}));
/**
 * All events posted to iframe
 */
export var MSG_NAME_TO_IFRAME;
(function (MSG_NAME_TO_IFRAME) {
    MSG_NAME_TO_IFRAME["FsUpdateVisitorAllocatedVariation"] = "FS_UPDATE_VISITOR_ALLOCATED_VARIATION";
    MSG_NAME_TO_IFRAME["FsVisitorExposedVariation"] = "FS_VISITOR_EXPOSED_VARIATION";
    MSG_NAME_TO_IFRAME["FsHIT"] = "FS_HIT";
})(MSG_NAME_TO_IFRAME || (MSG_NAME_TO_IFRAME = {}));
export var VisitorVariationUpdateParam;
(function (VisitorVariationUpdateParam) {
    VisitorVariationUpdateParam["NewNavigation"] = "newNavigation";
})(VisitorVariationUpdateParam || (VisitorVariationUpdateParam = {}));
export var INTERNAL_EVENTS;
(function (INTERNAL_EVENTS) {
    INTERNAL_EVENTS["FsTriggerRendering"] = "FS_TRIGGER_RENDERING";
})(INTERNAL_EVENTS || (INTERNAL_EVENTS = {}));
